export default "__VITE_ASSET__1PzHIPc8__"